import { render, staticRenderFns } from "./PricelistsRowsReadOnlyPanel.vue?vue&type=template&id=6cbd5312"
import script from "./PricelistsRowsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PricelistsRowsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./PricelistsRowsReadOnlyPanel.vue?vue&type=style&index=0&id=6cbd5312&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports